import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { WebinarSidebarFeature } from '../../../../sharedLegacy/features'
import { useInvalidatePollsQuery } from '../../Tray/hooks/use-polls'
import { getIsDraft } from '../../../selectors'
import {
  toggleQuestionOverlay as toggleQuestionOverlayAction,
  togglePollOverlay as togglePollOverlayAction,
} from '../../../actions'
import { useRoomGlobalInfo } from '../../../../global/blocs/roomInfo'
import { useSiteQuery } from '../../../../global/blocs/useSite'
import { useLiveDataQuery } from '../../../../global/blocs/useLiveData'

const Sidebar = ({
  /**
   * Connected properties
   */
  role,
  localParticipantName,
  isDraft,
  webinarLink,
  isInGearMode,
  questionOverlayCommentId,

  /**
   * Connected functions
   */
  toggleQuestionOverlay,
  togglePollOverlay,
}) => {
  const { liveId, presenterToken } = useRoomGlobalInfo()
  const { data: siteData } = useSiteQuery()

  const { data: liveData } = useLiveDataQuery()

  const invalidate = useInvalidatePollsQuery(liveId)

  if (!liveData) {
    return null
  }

  const webinarViewLink =
    webinarLink && `${siteData?.https_url ?? ''}${webinarLink}`

  return (
    <WebinarSidebarFeature
      namespace="webinar-room-sidebar"
      role={role}
      liveId={liveId}
      defaultSidebarTab="audience"
      localParticipantName={localParticipantName}
      presenterToken={presenterToken}
      webinarViewLink={webinarViewLink}
      isDraft={isDraft}
      toggleQuestionOverlay={toggleQuestionOverlay}
      questionOverlayCommentId={questionOverlayCommentId}
      togglePollOverlay={togglePollOverlay}
      isInGearMode={isInGearMode}
      onInvalidatePolls={invalidate}
    />
  )
}

Sidebar.propTypes = {
  /**
   * Connected properties
   */
  role: PropTypes.oneOf(['presenter', 'producer']),
  localParticipantName: PropTypes.string,
  isDraft: PropTypes.bool,
  webinarLink: PropTypes.string,
  isInGearMode: PropTypes.bool,
  questionOverlayCommentId: PropTypes.string,

  /**
   * Connected functions
   */
  toggleQuestionOverlay: PropTypes.func,
  togglePollOverlay: PropTypes.func,
}

const mapStateToProps = (state) => ({
  /**
   * Connected properties
   */
  role: state.webinar.role,
  localParticipantName: state.webinar.localParticipantName,
  isDraft: getIsDraft(state),
  webinarLink: state.webinar.liveData.link,
  isInGearMode: state.webinar.isGearMode,
  liveId: state.webinar.liveId,
  questionOverlayCommentId: state.webinar.questionOverlayCommentId,
})

const mapDispatchToProps = {
  /**
   * Connected functions
   */
  toggleQuestionOverlay: toggleQuestionOverlayAction,
  togglePollOverlay: togglePollOverlayAction,
}

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar)
